/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaStreamCastOffIcon16Light } from './MediaStreamCastOffIcon16Light';
import { MediaStreamCastOffIcon16Regular } from './MediaStreamCastOffIcon16Regular';
import { MediaStreamCastOffIcon16Solid } from './MediaStreamCastOffIcon16Solid';
import { MediaStreamCastOffIcon20Light } from './MediaStreamCastOffIcon20Light';
import { MediaStreamCastOffIcon20Regular } from './MediaStreamCastOffIcon20Regular';
import { MediaStreamCastOffIcon20Solid } from './MediaStreamCastOffIcon20Solid';
import { MediaStreamCastOffIcon24Regular } from './MediaStreamCastOffIcon24Regular';
import { MediaStreamCastOffIcon24Solid } from './MediaStreamCastOffIcon24Solid';
import { MediaStreamCastOffIcon32Regular } from './MediaStreamCastOffIcon32Regular';
import { MediaStreamCastOffIcon64Regular } from './MediaStreamCastOffIcon64Regular';
var sizes = {
    16: {
        light: MediaStreamCastOffIcon16Light,
        regular: MediaStreamCastOffIcon16Regular,
        solid: MediaStreamCastOffIcon16Solid,
    },
    20: {
        light: MediaStreamCastOffIcon20Light,
        regular: MediaStreamCastOffIcon20Regular,
        solid: MediaStreamCastOffIcon20Solid,
    },
    24: {
        regular: MediaStreamCastOffIcon24Regular,
        solid: MediaStreamCastOffIcon24Solid,
    },
    32: {
        regular: MediaStreamCastOffIcon32Regular,
    },
    64: {
        regular: MediaStreamCastOffIcon64Regular,
    },
};
export var MediaStreamCastOffIcon = forwardRef('MediaStreamCastOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
